module.exports = __webpack_public_path__ + "3b8260d491f0ed64b1ad45d0e624888d.svg";